import { render, staticRenderFns } from "./cri.vue?vue&type=template&id=4f8df8ac&scoped=true&"
import script from "./cri.vue?vue&type=script&lang=js&"
export * from "./cri.vue?vue&type=script&lang=js&"
import style0 from "./cri.vue?vue&type=style&index=0&id=4f8df8ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8df8ac",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8df8ac')) {
      api.createRecord('4f8df8ac', component.options)
    } else {
      api.reload('4f8df8ac', component.options)
    }
    module.hot.accept("./cri.vue?vue&type=template&id=4f8df8ac&scoped=true&", function () {
      api.rerender('4f8df8ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/tiposAtivos/RendaFixa/cri.vue"
export default component.exports